import { FC, KeyboardEvent, ReactNode } from 'react';
import { NavCloseIcon } from 'assets/icons';
import { SidePanel } from 'components';

interface DisputeOverviewShellProps {
  onClose: () => void;
  shouldAnimate?: boolean;
  children: ReactNode;
}

const DisputeOverviewShell: FC<DisputeOverviewShellProps> = ({ onClose, shouldAnimate, children }) => {
  const handleCloseKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    onClose();
  };

  return (
    <SidePanel isOpen={true} onClose={onClose} shouldAnimate={shouldAnimate}>
      <div className="flex h-full w-96 flex-col">
        <div className="flex h-full w-full flex-col gap-5 pt-5">
          <div className="flex w-full items-center gap-2 pl-[14px]">
            <div
              onClick={onClose}
              onKeyDown={handleCloseKeyDown}
              className="cursor-pointer"
              role="button"
              tabIndex={0}
              aria-label="Close disputes overview">
              <NavCloseIcon id="dispute-overview-close" />
            </div>
            <div className="text-17px font-semibold text-heading">Disputes</div>
          </div>
          <div className="customNormalScroll min-h-0 flex-1 overflow-auto px-6 pb-6">{children}</div>
        </div>
      </div>
    </SidePanel>
  );
};

export default DisputeOverviewShell;
